/* ============================================================================
FILE: po-katupirsia5-sceau-d-aisthisi-texts-fr-en-es-20260307.js

MODE: TRILINGUE (FR/EN/ES) + lexicon injection (if present)

API:  window.PoKatupirsia5SceauDAisthisiTextsFR_EN_ES_20260307

ROOT: .po-axis-section[data-po-axis]

ROLE:
  - Injecte le contenu FR/EN/ES dans les slots selon la langue (navigateur ou storage).
  - Protection fine: verrouille (translate="no") TOUTES les occurrences du lexique simplifié (si disponible),
    avec variantes apostrophes + œ/oe, et anti-collage (espaces DOM/HTML uniquement quand nécessaire).
  - IMPORTANT: les termes du lexique (et variantes) restent en FR, quelle que soit la langue affichée.
  - Compat: conserve un alias API window.GoodyTwinLang (getLang/setLang/init) pour éviter de casser d’anciens appels.
  - Ajoute une couche audio locale et générale sans toucher au socle multilingue, au nom du fichier,
    ni aux protections lexicales.
============================================================================ */

(function(){

  "use strict";

  if (window.__PO_KATUPIRSIA5_SCEAU_D_AISTHISI_TEXTS_20260307__) return;
  window.__PO_KATUPIRSIA5_SCEAU_D_AISTHISI_TEXTS_20260307__ = true;

  window.__POLEX_RUNTIME_INIT__ = true;

  var STORAGE_KEY = "po_lex_lang";
  var STORAGE_KEY_COMPAT = "goody_gp_lang";
  var ROOT_SEL = '.po-axis-section[data-po-axis]';

  function clampStr(v){ return (v == null) ? "" : String(v); }

  function normLang(raw){
    var v = (raw == null) ? "" : String(raw);
    v = v.toLowerCase().trim();
    if (v.indexOf("fr") === 0) return "fr";
    if (v.indexOf("en") === 0) return "en";
    if (v.indexOf("es") === 0) return "es";
    return "";
  }

  function readStoredLang(){
    try{
      var v = localStorage.getItem(STORAGE_KEY);
      v = normLang(v);
      if (v) return v;
    }catch(e){}
    try{
      var v2 = localStorage.getItem(STORAGE_KEY_COMPAT);
      v2 = normLang(v2);
      if (v2) return v2;
    }catch(e){}
    return "";
  }

  function storeLang(lang){
    var v = normLang(lang) || "fr";
    try{ localStorage.setItem(STORAGE_KEY, v); }catch(e){}
    try{ localStorage.setItem(STORAGE_KEY_COMPAT, v); }catch(e){}
    try{ document.documentElement.setAttribute("lang", v); }catch(e){}
  }

  function detectBrowserLang(){
    try{
      var n = (navigator && (navigator.language || (navigator.languages && navigator.languages[0]))) || "";
      var v = normLang(n);
      if (v) return v;
    }catch(e){}
    return "fr";
  }

  function getLang(){
    return readStoredLang() || detectBrowserLang() || "fr";
  }

  function notifyLocaleChanged(){
    try{
      window.dispatchEvent(new Event("po:locale-changed"));
    }catch(e){
      try{
        var ev = document.createEvent("Event");
        ev.initEvent("po:locale-changed", true, true);
        window.dispatchEvent(ev);
      }catch(_e){}
    }
  }

  /* --------------------------------------------------------------------------
   * LEXIQUE RUNTIME
   * -------------------------------------------------------------------------- */

  function getLexiconEntry(id){
    try{
      if (window.PO_LEXICON_MAP && window.PO_LEXICON_MAP[id]) return window.PO_LEXICON_MAP[id];
    }catch(e){}

    try{
      var arr = window.PO_LEXICON;
      if (Array.isArray(arr)){
        for (var i=0;i<arr.length;i++){
          if (arr[i] && arr[i].id === id) return arr[i];
        }
      }
    }catch(e){}

    return null;
  }

  function pickTerm(entry, lang){
    if (!entry) return "";
    try{
      if (entry.terms && entry.terms[lang]) return clampStr(entry.terms[lang]);
    }catch(e){}
    return "";
  }

  function pickDefShort(entry, lang){
    if (!entry) return "";
    var ks = "definition_short_" + lang;
    var k  = "definition_" + lang;
    try{
      if (entry[ks]) return clampStr(entry[ks]);
      if (entry[k])  return clampStr(entry[k]);
    }catch(e){}
    return "";
  }

  function pickDefLong(entry, lang){
    if (!entry) return "";
    var kl = "definition_long_" + lang;
    var k  = "definition_" + lang;
    try{
      if (entry[kl]) return clampStr(entry[kl]);
      if (entry[k])  return clampStr(entry[k]);
    }catch(e){}
    return "";
  }

  function pickArray(entry, lang, base){
    if (!entry) return [];
    var k = base + "_" + lang;
    try{
      var v = entry[k];
      if (Array.isArray(v)) return v;
    }catch(e){}
    return [];
  }

  /* --------------------------------------------------------------------------
   * PROTECTION fine
   * -------------------------------------------------------------------------- */

  function protectSpan(txt){
    return '<span translate="no" class="po-lex-protect">' + clampStr(txt) + "</span>";
  }

  function uniqPush(arr, v){
    if (!v) return;
    for (var i=0;i<arr.length;i++){
      if (arr[i] === v) return;
    }
    arr.push(v);
  }

  function buildVariants(term){
    var out = [];
    var t = clampStr(term);
    if (!t) return out;

    uniqPush(out, t);

    var a1 = t.replace(/’/g, "'");
    var a2 = t.replace(/'/g, "’");
    uniqPush(out, a1);
    uniqPush(out, a2);

    var oe1 = t.replace(/œ/g, "oe").replace(/Œ/g, "OE");
    uniqPush(out, oe1);

    var oe2 = t.replace(/oe/g, "œ").replace(/OE/g, "Œ");
    uniqPush(out, oe2);

    uniqPush(out, oe1.replace(/’/g, "'"));
    uniqPush(out, oe1.replace(/'/g, "’"));
    uniqPush(out, oe2.replace(/’/g, "'"));
    uniqPush(out, oe2.replace(/'/g, "’"));

    return out;
  }

  function getSimplifiedLexiqueFRList(){
    try{
      if (window.PO_LEXICON_META && Array.isArray(window.PO_LEXICON_META.lexique_simplifie_fr)){
        return window.PO_LEXICON_META.lexique_simplifie_fr.slice();
      }
    }catch(e){}

    try{
      if (window.PO_LEXICON && window.PO_LEXICON.meta && Array.isArray(window.PO_LEXICON.meta.lexique_simplifie_fr)){
        return window.PO_LEXICON.meta.lexique_simplifie_fr.slice();
      }
    }catch(e){}

    try{
      if (window.PO_LEXIQUE_SIMPLIFIE && window.PO_LEXIQUE_SIMPLIFIE.meta &&
          Array.isArray(window.PO_LEXIQUE_SIMPLIFIE.meta.lexique_simplifie_fr)){
        return window.PO_LEXIQUE_SIMPLIFIE.meta.lexique_simplifie_fr.slice();
      }
    }catch(e){}

    try{
      if (Array.isArray(window.PO_LEXIQUE_SIMPLIFIE_FR)){
        return window.PO_LEXIQUE_SIMPLIFIE_FR.slice();
      }
    }catch(e){}

    return [
      "Sceau d’Aísthisi",
      "Aísthisi",
      "Aísthēra",
      "Posœnnoïsme",
      "Posœnnoïa",
      "Organon posœnnoïal",
      "Katûvýsissence",
      "Katûvýs",
      "Ennéagone",
      "Ennéagone régulateur",
      "Isqun",
      "Threnisqun",
      "Posœnnomia",
      "RéZonans",
      "Péroptissimisme",
      "Aliœvolution",
      "Illusion",
      "Addition synchrêtique",
      "Instantané multiple",
      "Superposition de perspectives",
      "Sujet pluriel",
      "Humanus",
      "Balakallpa",
      "Katûsýs",
      "Katûvýsqun",
      "Katûpirsia",
      "VITRIOL"
    ];
  }

  function escapeRegExp(s){
    return String(s).replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
  }

  function buildProtectMatcher(){
    var base = getSimplifiedLexiqueFRList();
    var variants = [];

    for (var i=0;i<base.length;i++){
      var vlist = buildVariants(base[i]);
      for (var j=0;j<vlist.length;j++){
        uniqPush(variants, vlist[j]);
      }
    }

    variants.sort(function(a,b){ return b.length - a.length; });

    var parts = [];
    for (var k=0;k<variants.length;k++){
      if (!variants[k]) continue;
      parts.push(escapeRegExp(variants[k]));
    }
    if (!parts.length) return null;

    try{
      return new RegExp("(" + parts.join("|") + ")", "g");
    }catch(e){
      return null;
    }
  }

  var __PO_PROTECT_RE__ = null;

  function protectKeywordsHTML(html){
    if (!html) return "";
    var out = String(html);

    if (!__PO_PROTECT_RE__){
      __PO_PROTECT_RE__ = buildProtectMatcher();
    }
    if (__PO_PROTECT_RE__){
      out = out.replace(__PO_PROTECT_RE__, function(m){
        return protectSpan(m);
      });
    }

    out = out.replace(/([0-9A-Za-zÀ-ÖØ-öø-ÿ])(<span translate="no" class="po-lex-protect">)/g, "$1 $2");
    out = out.replace(/(<\/span>)([0-9A-Za-zÀ-ÖØ-öø-ÿ])/g, "$1 $2");
    out = out.replace(/(<\/span>)(<[^\/\s>])/g, "$1 $2");
    out = out.replace(/([^\s>])(<span translate="no" class="po-lex-protect">)/g, function(_m, a, b){
      if (a === " " || a === ">") return a + b;
      return a + " " + b;
    });

    return out;
  }

  /* --------------------------------------------------------------------------
   * AUDIO LOCAL PAR BLOC + TEXTE GÉNÉRAL
   * -------------------------------------------------------------------------- */

  var PO_AUDIO_SYNTH = (typeof window !== "undefined" && window.speechSynthesis) ? window.speechSynthesis : null;
  var PO_AUDIO_STATE = {
    root: null,
    units: [],
    unitPos: -1,
    chunks: [],
    chunkPos: -1,
    activeKey: "",
    lang: "fr",
    voice: null
  };

  var AUDIO_UI = {
    fr: { general: "Écouter le texte", block: "Écouter ce bloc", stop: "Arrêter la lecture" },
    en: { general: "Listen to the text", block: "Listen to this section", stop: "Stop playback" },
    es: { general: "Escuchar el texto", block: "Escuchar este bloque", stop: "Detener la lectura" }
  };

  function audioUI(lang){
    var L = normLang(lang);
    return AUDIO_UI[L] || AUDIO_UI.fr;
  }

  function getAudioRoots(){
    try{ return document.querySelectorAll(ROOT_SEL); }catch(e){ return []; }
  }

  function getDetailBlocks(root){
    if (!root || !root.querySelectorAll) return [];
    try{ return root.querySelectorAll(".po-lex-details"); }catch(e){ return []; }
  }

  function ensureAudioStyles(){
    if (document.getElementById("po-axis-audio-styles")) return;
    var style = document.createElement("style");
    style.id = "po-axis-audio-styles";
    style.textContent =
      ".po-axis-audio-wrap{display:flex;align-items:center;gap:.6rem;margin:1rem 0 1.15rem 0;justify-content:flex-start;}" +
      ".po-axis-audio-btn{appearance:none;-webkit-appearance:none;border:1px solid rgba(184,134,11,.55);background:rgba(31,122,58,.04);color:var(--color-accent,#1f7a3a);padding:.55rem .9rem;border-radius:999px;cursor:pointer;font:inherit;font-weight:800;line-height:1.2;transition:opacity .2s ease,transform .2s ease,box-shadow .2s ease,border-color .2s ease;box-shadow:0 6px 16px rgba(31,122,58,.10);}" +
      ".po-axis-audio-btn:hover{transform:translateY(-1px);box-shadow:0 10px 26px rgba(31,122,58,.16);border-color:rgba(184,134,11,.75);}" +
      ".po-axis-audio-btn[aria-pressed='true']{box-shadow:0 0 0 1px rgba(184,134,11,.18),0 10px 26px rgba(31,122,58,.18);background:rgba(31,122,58,.08);}" +
      ".po-lex-summary .po-axis-audio-btn{margin-left:.75rem;vertical-align:middle;flex:0 0 auto;}" +
      "@media (max-width:640px){.po-lex-summary{flex-wrap:wrap;}.po-lex-summary .po-axis-audio-btn{display:block;margin:.65rem 0 0 0;}}";
    document.head.appendChild(style);
  }

  function createAudioButton(role){
    var btn = document.createElement("button");
    btn.type = "button";
    btn.className = "po-axis-audio-btn";
    btn.setAttribute("data-po-audio-role", role === "general" ? "general" : "detail");
    btn.setAttribute("aria-pressed", "false");
    btn.setAttribute("translate", "yes");
    return btn;
  }

  function ensureAudioButtons(root){
    if (!root) return;
    ensureAudioStyles();

    var panel = root.querySelector(".po-lex-panel");
    if (panel){
      var generalWrap = root.querySelector(".po-axis-audio-wrap[data-po-audio-role='general']");
      if (!generalWrap){
        generalWrap = document.createElement("div");
        generalWrap.className = "po-axis-audio-wrap";
        generalWrap.setAttribute("data-po-audio-role", "general");

        var generalBtn = createAudioButton("general");
        generalWrap.appendChild(generalBtn);

        var meta = root.querySelector(".po-axis-meta");
        var defShort = root.querySelector("[data-po-slot='def_short']");
        var firstDetail = panel.querySelector(".po-lex-details");

        if (meta && meta.parentNode){
          if (meta.nextSibling) meta.parentNode.insertBefore(generalWrap, meta.nextSibling);
          else meta.parentNode.appendChild(generalWrap);
        } else if (defShort && defShort.parentNode){
          defShort.parentNode.insertBefore(generalWrap, defShort);
        } else if (firstDetail && firstDetail.parentNode){
          firstDetail.parentNode.insertBefore(generalWrap, firstDetail);
        } else {
          panel.appendChild(generalWrap);
        }
      }
    }

    var details = getDetailBlocks(root);
    for (var i=0;i<details.length;i++){
      var detail = details[i];
      var summary = detail.querySelector(".po-lex-summary");
      if (!summary) continue;

      var btn = summary.querySelector(".po-axis-audio-btn[data-po-audio-role='detail']");
      if (!btn){
        btn = createAudioButton("detail");
        summary.appendChild(btn);
      }
      btn.setAttribute("data-po-audio-index", String(i));
    }
  }

  function getTextValue(el){
    if (!el) return "";
    var txt = "";
    try{ txt = el.innerText || el.textContent || ""; }catch(e){ txt = ""; }
    txt = String(txt).replace(/\s+/g, " ").replace(/\u00a0/g, " ").trim();
    return txt;
  }

  function removeAudioButtonsFromClone(root){
    if (!root || !root.querySelectorAll) return;
    var btns = root.querySelectorAll(".po-axis-audio-btn, .po-axis-audio-wrap");
    for (var i=0;i<btns.length;i++){
      var btn = btns[i];
      if (btn && btn.parentNode) btn.parentNode.removeChild(btn);
    }
  }

  function collectGeneralText(root){
    var parts = [];
    var slots = ["title", "kicker", "h_def", "def_short", "def_long"];
    for (var i=0;i<slots.length;i++){
      var el = root.querySelector("[data-po-slot='" + slots[i] + "']");
      var txt = getTextValue(el);
      if (txt) parts.push(txt);
    }
    return parts.join(". ");
  }

  function collectDetailText(detail){
    if (!detail) return "";
    var parts = [];

    var title = detail.querySelector(".po-lex-summary__title");
    var titleText = getTextValue(title);
    if (titleText) parts.push(titleText);

    var clone = detail.cloneNode(true);
    var summary = clone.querySelector(".po-lex-summary");
    if (summary && summary.parentNode) summary.parentNode.removeChild(summary);
    removeAudioButtonsFromClone(clone);

    var bodyText = getTextValue(clone);
    if (bodyText) parts.push(bodyText);

    return parts.join(". ");
  }

  function isWordLikeChar(ch){
    return /[0-9A-Za-zÀ-ÖØ-öø-ÿ]/.test(ch || "");
  }

  function splitTextForSpeech(txt, maxLen){
    var text = clampStr(txt).replace(/\s+/g, " ").trim();
    if (!text) return [];
    var limit = Math.max(120, parseInt(maxLen, 10) || 200);
    var out = [];
    var start = 0;

    while (start < text.length){
      var end = Math.min(start + limit, text.length);
      if (end < text.length){
        var slice = text.slice(start, end);
        var cut = Math.max(
          slice.lastIndexOf(". "),
          slice.lastIndexOf("! "),
          slice.lastIndexOf("? "),
          slice.lastIndexOf("; "),
          slice.lastIndexOf(": "),
          slice.lastIndexOf(", ")
        );
        if (cut < Math.floor(limit * 0.55)){
          cut = slice.lastIndexOf(" ");
        }
        if (cut > 0) end = start + cut + 1;
      }

      while (end < text.length && isWordLikeChar(text.charAt(end - 1)) && isWordLikeChar(text.charAt(end))){
        end++;
      }

      var chunk = text.slice(start, end).trim();
      if (chunk) out.push(chunk);
      start = end;
    }

    return out;
  }

  function pickVoiceForLang(lang){
    if (!PO_AUDIO_SYNTH || typeof PO_AUDIO_SYNTH.getVoices !== "function") return null;
    var wanted = normLang(lang) || "fr";
    var voices = [];
    try{ voices = PO_AUDIO_SYNTH.getVoices() || []; }catch(e){ voices = []; }
    if (!voices.length) return null;

    var i, v, voiceLang;
    for (i=0;i<voices.length;i++){
      v = voices[i];
      voiceLang = normLang(v && v.lang);
      if (voiceLang === wanted) return v;
    }
    for (i=0;i<voices.length;i++){
      v = voices[i];
      voiceLang = clampStr(v && v.lang).toLowerCase();
      if (voiceLang.indexOf(wanted) === 0) return v;
    }
    return voices[0] || null;
  }

  function buildUnits(root, role, index){
    var units = [];
    var details = getDetailBlocks(root);

    if (role === "general"){
      units.push({ role: "general", index: -1 });
      for (var i=0;i<details.length;i++){
        units.push({ role: "detail", index: i });
      }
      return units;
    }

    var start = (typeof index === "number" && index >= 0) ? index : 0;
    for (var j=start;j<details.length;j++){
      units.push({ role: "detail", index: j });
    }
    return units;
  }

  function updateAudioPressedState(){
    var roots = getAudioRoots();
    for (var i=0;i<roots.length;i++){
      var root = roots[i];
      var btns = root.querySelectorAll(".po-axis-audio-btn");
      for (var j=0;j<btns.length;j++){
        btns[j].setAttribute("aria-pressed", "false");
      }
    }

    if (!PO_AUDIO_STATE.root || !PO_AUDIO_STATE.activeKey) return;

    var btn;
    if (PO_AUDIO_STATE.activeKey === "general"){
      btn = PO_AUDIO_STATE.root.querySelector(".po-axis-audio-wrap[data-po-audio-role='general'] .po-axis-audio-btn[data-po-audio-role='general']");
      if (btn) btn.setAttribute("aria-pressed", "true");
      return;
    }

    var idx = parseInt(String(PO_AUDIO_STATE.activeKey).split(":")[1], 10);
    if (!isNaN(idx)){
      btn = PO_AUDIO_STATE.root.querySelector(".po-axis-audio-btn[data-po-audio-role='detail'][data-po-audio-index='" + idx + "']");
      if (btn) btn.setAttribute("aria-pressed", "true");
    }
  }

  function refreshAudioLabels(root, lang){
    if (!root) return;
    var ui = audioUI(lang || getLang());

    var generalBtn = root.querySelector(".po-axis-audio-wrap[data-po-audio-role='general'] .po-axis-audio-btn[data-po-audio-role='general']");
    if (generalBtn){
      var generalActive = (PO_AUDIO_STATE.root === root && PO_AUDIO_STATE.activeKey === "general" && PO_AUDIO_SYNTH && (PO_AUDIO_SYNTH.speaking || PO_AUDIO_SYNTH.pending));
      generalBtn.textContent = generalActive ? ui.stop : ui.general;
    }

    var detailBtns = root.querySelectorAll(".po-axis-audio-btn[data-po-audio-role='detail']");
    for (var i=0;i<detailBtns.length;i++){
      var btn = detailBtns[i];
      var idx = parseInt(btn.getAttribute("data-po-audio-index"), 10);
      var key = "detail:" + (isNaN(idx) ? -1 : idx);
      var active = (PO_AUDIO_STATE.root === root && PO_AUDIO_STATE.activeKey === key && PO_AUDIO_SYNTH && (PO_AUDIO_SYNTH.speaking || PO_AUDIO_SYNTH.pending));
      btn.textContent = active ? ui.stop : ui.block;
    }

    updateAudioPressedState();
  }

  function refreshAllAudioLabels(lang){
    var roots = getAudioRoots();
    for (var i=0;i<roots.length;i++){
      refreshAudioLabels(roots[i], lang || getLang());
    }
  }

  function stopAudio(silent){
    if (PO_AUDIO_SYNTH){
      try{ PO_AUDIO_SYNTH.cancel(); }catch(e){}
    }
    PO_AUDIO_STATE.root = null;
    PO_AUDIO_STATE.units = [];
    PO_AUDIO_STATE.unitPos = -1;
    PO_AUDIO_STATE.chunks = [];
    PO_AUDIO_STATE.chunkPos = -1;
    PO_AUDIO_STATE.activeKey = "";
    PO_AUDIO_STATE.voice = null;
    if (!silent) refreshAllAudioLabels(getLang());
    else updateAudioPressedState();
  }

  function speakCurrentChunk(){
    if (!PO_AUDIO_SYNTH) return;

    if (!PO_AUDIO_STATE.chunks.length || PO_AUDIO_STATE.chunkPos < 0 || PO_AUDIO_STATE.chunkPos >= PO_AUDIO_STATE.chunks.length){
      PO_AUDIO_STATE.unitPos += 1;
      playCurrentUnit(true);
      return;
    }

    var txt = PO_AUDIO_STATE.chunks[PO_AUDIO_STATE.chunkPos];
    if (!txt){
      PO_AUDIO_STATE.chunkPos += 1;
      speakCurrentChunk();
      return;
    }

    var utter = new SpeechSynthesisUtterance(txt);
    utter.lang = (PO_AUDIO_STATE.lang || getLang() || "fr");
    if (PO_AUDIO_STATE.voice) utter.voice = PO_AUDIO_STATE.voice;

    utter.onend = function(){
      PO_AUDIO_STATE.chunkPos += 1;
      speakCurrentChunk();
    };

    utter.onerror = function(){
      PO_AUDIO_STATE.chunkPos += 1;
      speakCurrentChunk();
    };

    try{ PO_AUDIO_SYNTH.speak(utter); }catch(e){
      PO_AUDIO_STATE.chunkPos += 1;
      speakCurrentChunk();
    }
  }

  function playCurrentUnit(skipCancel){
    if (!PO_AUDIO_SYNTH) return;

    if (!skipCancel){
      try{ PO_AUDIO_SYNTH.cancel(); }catch(e){}
    }

    if (!PO_AUDIO_STATE.root || PO_AUDIO_STATE.unitPos < 0 || PO_AUDIO_STATE.unitPos >= PO_AUDIO_STATE.units.length){
      stopAudio();
      return;
    }

    var unit = PO_AUDIO_STATE.units[PO_AUDIO_STATE.unitPos];
    if (!unit){
      stopAudio();
      return;
    }

    var text = "";
    if (unit.role === "general"){
      PO_AUDIO_STATE.activeKey = "general";
      text = collectGeneralText(PO_AUDIO_STATE.root);
    } else {
      PO_AUDIO_STATE.activeKey = "detail:" + unit.index;
      var details = getDetailBlocks(PO_AUDIO_STATE.root);
      var detail = details[unit.index];
      if (detail){
        try{ detail.open = true; }catch(e){}
      }
      text = collectDetailText(detail);
    }

    PO_AUDIO_STATE.chunks = splitTextForSpeech(text, 210);
    PO_AUDIO_STATE.chunkPos = 0;
    refreshAllAudioLabels(PO_AUDIO_STATE.lang || getLang());

    if (!PO_AUDIO_STATE.chunks.length){
      PO_AUDIO_STATE.unitPos += 1;
      playCurrentUnit(true);
      return;
    }

    speakCurrentChunk();
  }

  function startAudio(root, role, index){
    if (!PO_AUDIO_SYNTH || !root) return;
    stopAudio(true);

    var lang = getLang();

    PO_AUDIO_STATE.root = root;
    PO_AUDIO_STATE.units = buildUnits(root, role, index);
    PO_AUDIO_STATE.unitPos = 0;
    PO_AUDIO_STATE.chunks = [];
    PO_AUDIO_STATE.chunkPos = -1;
    PO_AUDIO_STATE.activeKey = "";
    PO_AUDIO_STATE.lang = lang;
    PO_AUDIO_STATE.voice = pickVoiceForLang(lang);

    refreshAllAudioLabels(lang);
    playCurrentUnit(false);
  }

  function bindAudioButtons(root){
    if (!root) return;
    var btns = root.querySelectorAll(".po-axis-audio-btn");
    for (var i=0;i<btns.length;i++){
      var btn = btns[i];
      if (btn.__poAudioBound) continue;

      btn.addEventListener("click", function(ev){
        ev.preventDefault();
        ev.stopPropagation();

        var role = this.getAttribute("data-po-audio-role") || "detail";
        var index = parseInt(this.getAttribute("data-po-audio-index"), 10);
        var key = (role === "general") ? "general" : ("detail:" + (isNaN(index) ? -1 : index));
        var sameRoot = (PO_AUDIO_STATE.root === root);
        var sameKey = (PO_AUDIO_STATE.activeKey === key);

        if (sameRoot && sameKey && (PO_AUDIO_SYNTH && (PO_AUDIO_SYNTH.speaking || PO_AUDIO_SYNTH.pending))){
          stopAudio();
          return;
        }

        startAudio(root, role, isNaN(index) ? -1 : index);
      });

      btn.__poAudioBound = true;
    }
  }

  function initAudioEverywhere(lang){
    var roots = getAudioRoots();
    for (var i=0;i<roots.length;i++){
      ensureAudioButtons(roots[i]);
      bindAudioButtons(roots[i]);
      refreshAudioLabels(roots[i], lang || getLang());
    }
  }

  try{
    if (PO_AUDIO_SYNTH && typeof PO_AUDIO_SYNTH.addEventListener === "function"){
      PO_AUDIO_SYNTH.addEventListener("voiceschanged", function(){
        if (PO_AUDIO_STATE.root){
          PO_AUDIO_STATE.voice = pickVoiceForLang(PO_AUDIO_STATE.lang || getLang());
        }
      });
    }
  }catch(e){}

  /* --------------------------------------------------------------------------
   * SLOTS helpers
   * -------------------------------------------------------------------------- */

  function qs(root, sel){
    try{ return root.querySelector(sel); }catch(e){ return null; }
  }

  function setSlotText(root, slot, txt){
    var el = qs(root, '[data-po-slot="'+slot+'"]');
    if (!el) return;
    el.textContent = clampStr(txt);
  }

  function setSlotHTML(root, slot, html){
    var el = qs(root, '[data-po-slot="'+slot+'"]');
    if (!el) return;
    el.innerHTML = protectKeywordsHTML(html);
  }

  function setSlotImg(root, slot, src, alt){
    var el = qs(root, '[data-po-slot="'+slot+'"]');
    if (!el) return;

    var s = clampStr(src);
    var a = clampStr(alt);

    if (!s){
      try{ el.removeAttribute("src"); }catch(e){}
      try{ el.setAttribute("alt",""); }catch(e){}
      try{ el.style.display = "none"; }catch(e){}
      return;
    }

    try{ el.setAttribute("src", s); }catch(e){}
    try{ el.setAttribute("alt", a); }catch(e){}
    try{ el.style.display = ""; }catch(e){}
  }

  function setSlotImgSrc(root, slot, src, alt){
    setSlotImg(root, slot, src, alt);
  }

  function renderList(root, slot, items){
    var el = qs(root, '[data-po-slot="'+slot+'"]');
    if (!el) return;
    var arr = Array.isArray(items) ? items : [];
    var out = [];
    for (var i=0;i<arr.length;i++){
      out.push("<li>" + protectKeywordsHTML(clampStr(arr[i])) + "</li>");
    }
    el.innerHTML = out.join("");
  }

  function renderExampleBox(root, slot, exampleTitle, exampleText){
    var el = qs(root, '[data-po-slot="'+slot+'"]');
    if (!el) return;
    var t = clampStr(exampleTitle);
    var x = clampStr(exampleText);
    if (!t && !x){
      el.innerHTML = "";
      return;
    }
    var html = '<div class="po-lex-example__title"><strong>' + protectKeywordsHTML(t) + '</strong></div>' +
               '<div class="po-lex-example__text">' + protectKeywordsHTML(x) + "</div>";
    el.innerHTML = html;
  }

  function renderWordBlocks(root, slot, blocks){
    var el = qs(root, '[data-po-slot="'+slot+'"]');
    if (!el) return;
    var arr = Array.isArray(blocks) ? blocks : [];
    var out = [];
    for (var i=0;i<arr.length;i++){
      var b = arr[i] || {};
      var h = clampStr(b.head);
      var t = clampStr(b.text);
      out.push(
        '<div class="po-axis-wb">' +
          '<div class="po-axis-wb__h">' + protectKeywordsHTML(h) + '</div>' +
          '<div class="po-axis-wb__t">' + protectKeywordsHTML(t) + '</div>' +
        '</div>'
      );
    }
    el.innerHTML = out.join("");
  }

  /* --------------------------------------------------------------------------
   * IMAGES (Sceau d’Aísthisi)
   * -------------------------------------------------------------------------- */

  var IMG_IDEOGRAM_CONCEPT = "https://cdn.shopify.com/s/files/1/0851/1242/2733/files/Sceau_d_Aisthisi_720_2.png?v=1772896688";
  var IMG_IDEOGRAM_FUNCTION = "https://cdn.shopify.com/s/files/1/0851/1242/2733/files/Sceau_d_Aisthisi_720_2_copie.png?v=1772897503";
  var IMG_GUIDE_NUMBER_720 = "https://cdn.shopify.com/s/files/1/0851/1242/2733/files/Nombre_guide_720.png?v=1773448446";

  /* --------------------------------------------------------------------------
   * FALLBACKS
   * -------------------------------------------------------------------------- */

  var FALLBACK_FR = {
    title: "Sceau d’Aísthisi",
    kicker: "Katûpirsia 5 — Sceau régulateur de l’Ennéagone spiralé",
    cta_translate: "Proposer une traduction du concept",
    h_def: "Définition opérative",
    chips: ["Idéogramme conceptuel", "Idéogramme fonctionnel", "Nombre guide"],
    chip_urls: [ IMG_IDEOGRAM_CONCEPT, IMG_IDEOGRAM_FUNCTION, IMG_GUIDE_NUMBER_720 ],
    def_short:
      "Le Sceau d’Aísthisi est le régulateur des intensités perceptives et synesthésiques. Il rend l’afflux sensible habitable : absorbe l’excès, réoriente les flux, redistribue l’intensité en spirale d’écoute différée.",
    def_long:
      "Le Sceau d’Aísthisi agit lorsque l’expérience vécue déborde le contenant subjectif. Il intervient dans les surcharges visuelles, auditives, intuitives, dans les synesthésies non intégrées, dans les débordements émotionnels d’origine perceptive et dans certaines expériences spirituelles envahissantes. Il n’abolit pas l’expérience : il en ajuste la vitesse, la densité et la circulation.\n\n" +
      "Son lien matriciel relie les flux sensoriels internes au seuil poïétique d’incarnation vibrante. Lorsque la perception devient trop dense, Aísthisi ouvre une interface qui rend l’intensité habitable, en la réinscrivant dans une circulation spiralée. L’être retrouve sa tenue non par réduction, mais par redistribution.\n\n" +
      "K5 le situe comme seuil vivant au sein d’Isqun, pleinement katûvýsien, distinct de Katûsýs, de Balakallpa et de Katûvýsqun, tout en demeurant en syntonie étroite avec leurs activations lorsqu’elles intensifient le champ perceptif.",
    h_features: "Repères structurants",
    h_questions: "Repères d’activation",
    hint_fold: "déplier",
    example_title: "Formulation canonique",
    example:
      "1) Si la perception déborde : « Aísthisi régule ». 2) Si la synesthésie devient confusion : « Aísthisi redistribue ». 3) Si l’expérience écrase le corps : « Aísthisi ralentit ».",
    features: [
      "Statut : Sceau régulateur de l’Ennéagone spiralé.",
      "Lien matriciel : relie les flux sensoriels internes au seuil poïétique d’incarnation vibrante.",
      "Fonction principale : régulation des saturations perceptives.",
      "Nature : pleinement katûvýsien, distinct de Katûsýs, de Balakallpa et de Katûvýsqun.",
      "Fréquence harmonique : 720.",
      "Onde d’alignement commune Isqun–Threnisqun : 492.",
      "Champs d’action : surcharges visuelles, auditives, intuitives ; synesthésies non intégrées ; suractivations émotionnelles perceptives."
    ],
    questions: [
      "La perception déborde-t-elle le contenant subjectif ?",
      "S’agit-il d’une surcharge visuelle, auditive, intuitive ou émotionnelle perceptive ?",
      "La synesthésie actuelle éclaire-t-elle le vécu, ou produit-elle une confusion ?",
      "Quel média régulateur permet de ralentir l’afflux sans casser la RéZonans ?",
      "Faut-il assombrir, ralentir, respirer, écrire, ou entrer dans un bain vibratoire en cinq directions ?"
    ],
    h_family: "Affinités posœnnoïales",
    family_1:
      "<p><strong>Position dans La Katûvýs :</strong> le Sceau d’Aísthisi se situe aux frontières de l’expérience sensible et du seuil vibratoire symbolique. Il agit comme tampon fluide entre les <span translate=\"no\" class=\"po-lex-protect\">Katûvýsqun</span> les plus actifs — par exemple les VITRIOL ou les <span translate=\"no\" class=\"po-lex-protect\">Katûpirsia</span> intensément activées — et les structures perceptives du corps humain. Il est filtre poïétique, interface trans-sensorielle, régulateur de l’intensité vécue.</p>",
    family_2:
      "<p><strong>Entité isqunienne associée :</strong> <span translate=\"no\" class=\"po-lex-protect\">Aísthēra</span> est l’entité correspondante du Sceau d’Aísthisi. Elle opère comme densification localisée de la fonction régulatrice lorsque l’excès perceptif exige une intervention rituélique plus marquée. Elle recueille l’afflux, ralentit la surcharge et remet la perception en cadence habitable.</p>",
    h_wordbuild: "Positionnements & comparaisons",
    word_blocks: [
      {
        head: "Introduction canonique",
        text:
          "Aísthisi naît dans l’intensité où sentir déborde l’être. Les sens se parlent directement, les synesthésies deviennent primitives, l’afflux peut devenir torrent. Le Sceau offre alors équilibre dans l’excès, repos dans le trop-vu, le trop-entendu, le trop-ressenti."
      },
      {
        head: "Fréquence 720",
        text:
          "K5 fixe la charpente suivante : 720 = 441 + 279. 441 engage l’intuition poïétique, la vision symbolique, la perception profonde. 279 engage la perméabilité incarnée et l’intensité sensible structurée. La réduction 7 + 2 + 0 = 9 inscrit Aísthisi dans une logique d’intégration universelle par l’expérience."
      },
      {
        head: "Fonctionnement rituelo-symbolique",
        text:
          "Identifier la saturation, se placer en syntonie silencieuse ou en écoute vibratoire douce, activer un média régulateur — bain sonore, chant lent, mouvement fluide, repos immersif — puis conclure par écriture intuitive ou silence ritualisé afin d’inscrire la trace."
      },
      {
        head: "Redistribution sensorielle",
        text:
          "Visuelle : assombrissement ritualisé. Auditive : sons graves, rythme lent. Olfactive ou gustative : respiration douce. Intuitive ou émotionnelle : voix intérieure, écriture rituelle. Synesthésie généralisée : bain vibratoire en cinq directions."
      }
    ],
    word_notes: [
      "Aísthisi est le Sceau des hypersensibles, des poètes incarnés, des voyants du monde intérieur.",
      "Il ne nie pas l’expérience ; il en ajuste la vitesse, la densité et la circulation.",
      "Il transforme les chocs sensoriels en silences résonnants et en seuils de recomposition.",
      "Phrase opérative : « Aísthisi (720) : je reconnais la surcharge, je ralentis l’afflux, et je redistribue la perception en spirale d’écoute différée. »"
    ]
  };

  var FALLBACK_EN = {
    title: "Sceau d’Aísthisi",
    kicker: "Katûpirsia 5 — Sceau régulateur de l’Ennéagone spiralé",
    cta_translate: "Suggest a translation of the concept",
    h_def: "Operational definition",
    chips: ["Conceptual ideogram", "Functional ideogram", "Guide number"],
    chip_urls: [ IMG_IDEOGRAM_CONCEPT, IMG_IDEOGRAM_FUNCTION, IMG_GUIDE_NUMBER_720 ],
    def_short:
      "Sceau d’Aísthisi regulates perceptive and synesthetic intensities. It makes sensory influx inhabitable: absorbs excess, reorients flows, and redistributes intensity into a spiral of deferred listening.",
    def_long:
      "Sceau d’Aísthisi acts when lived experience exceeds the subject’s capacity of containment. It intervenes in visual, auditory, and intuitive overloads, in unintegrated synesthesia, in perceptive emotional overflow, and in certain overwhelming spiritual experiences. It does not abolish the experience: it adjusts its speed, density, and circulation.\n\n" +
      "Its matrix link connects internal sensory flows to the poietic threshold of vibratory incarnation. When perception becomes too dense, Aísthisi opens an interface that makes intensity inhabitable again by reinscribing it within a spiral circulation. Being regains its coherence not by reduction, but by redistribution.\n\n" +
      "K5 situates it as a living threshold within Isqun, fully katûvýsien, distinct from Katûsýs, Balakallpa, and Katûvýsqun, while remaining in close syntony with their activations whenever they intensify the perceptive field.",
    h_features: "Structural markers",
    h_questions: "Activation markers",
    hint_fold: "expand",
    example_title: "Canonical formulation",
    example:
      "1) If perception overflows: “Aísthisi regulates.” 2) If synesthesia becomes confusion: “Aísthisi redistributes.” 3) If experience crushes the body: “Aísthisi slows down.”",
    features: [
      "Status: Sceau régulateur de l’Ennéagone spiralé.",
      "Matrix link: connects internal sensory flows to the poietic threshold of vibratory incarnation.",
      "Main function: regulation of perceptive saturations.",
      "Nature: fully katûvýsien, distinct from Katûsýs, Balakallpa, and Katûvýsqun.",
      "Harmonic frequency: 720.",
      "Common alignment wave Isqun–Threnisqun: 492.",
      "Fields of action: visual, auditory, intuitive overloads; unintegrated synesthesia; perceptive emotional overactivation."
    ],
    questions: [
      "Does perception overflow the subject’s capacity of containment?",
      "Is this a visual, auditory, intuitive, or perceptive emotional overload?",
      "Does the present synesthesia clarify lived experience, or does it produce confusion?",
      "Which regulating medium can slow the influx without breaking RéZonans?",
      "Should one darken, slow down, breathe, write, or enter a five-direction vibratory bath?"
    ],
    h_family: "Posœnnoïal affinities",
    family_1:
      "<p><strong>Position in the Katûvýs:</strong> Sceau d’Aísthisi lies at the borders of sensible experience and the symbolic vibratory threshold. It acts as a fluid buffer between the most active <span translate=\"no\" class=\"po-lex-protect\">Katûvýsqun</span> — for example VITRIOL or intensely activated <span translate=\"no\" class=\"po-lex-protect\">Katûpirsia</span> — and the body’s perceptive structures. It is a poietic filter, a trans-sensorial interface, a regulator of lived intensity.</p>",
    family_2:
      "<p><strong>Associated Isqunian entity:</strong> <span translate=\"no\" class=\"po-lex-protect\">Aísthēra</span> is the corresponding entity of Sceau d’Aísthisi. It operates as a local densification of the regulatory function whenever perceptive excess requires a more marked ritual intervention. It receives the influx, slows the overload, and restores perception to an inhabitable cadence.</p>",
    h_wordbuild: "Positions & comparisons",
    word_blocks: [
      {
        head: "Canonical introduction",
        text:
          "Aísthisi is born in the intensity where sensing exceeds being. The senses speak directly to one another, synesthesia becomes primitive, and influx may become torrent. The seal then offers balance within excess, rest within the too-seen, too-heard, too-felt."
      },
      {
        head: "Frequency 720",
        text:
          "K5 fixes the following framework: 720 = 441 + 279. 441 engages poietic intuition, symbolic vision, deep perception. 279 engages embodied permeability and structured sensible intensity. The reduction 7 + 2 + 0 = 9 situates Aísthisi within a logic of universal integration through experience."
      },
      {
        head: "Ritual-symbolic functioning",
        text:
          "Identify the saturation, place oneself in silent syntony or gentle vibratory listening, activate a regulating medium — sound bath, slow chant, fluid movement, immersive rest — then conclude with intuitive writing or ritualised silence in order to inscribe the trace."
      },
      {
        head: "Sensory redistribution",
        text:
          "Visual: ritual darkening. Auditory: low sounds, slow rhythm. Olfactory or gustatory: soft breathing. Intuitive or emotional: inner voice, ritual writing. Generalised synesthesia: five-direction vibratory bath."
      }
    ],
    word_notes: [
      "Aísthisi is the seal of the hypersensitive, of embodied poets, of seers of the inner world.",
      "It does not deny experience; it adjusts its speed, density, and circulation.",
      "It transforms sensory shocks into resonant silences and thresholds of recomposition.",
      "Operative phrase: “Aísthisi (720): I recognise the overload, I slow the influx, and I redistribute perception into a spiral of deferred listening.”"
    ]
  };

  var FALLBACK_ES = {
    title: "Sceau d’Aísthisi",
    kicker: "Katûpirsia 5 — Sceau régulateur de l’Ennéagone spiralé",
    cta_translate: "Proponer una traducción del concepto",
    h_def: "Definición operativa",
    chips: ["Ideograma conceptual", "Ideograma funcional", "Número guía"],
    chip_urls: [ IMG_IDEOGRAM_CONCEPT, IMG_IDEOGRAM_FUNCTION, IMG_GUIDE_NUMBER_720 ],
    def_short:
      "Sceau d’Aísthisi regula las intensidades perceptivas y sinestésicas. Vuelve habitable el influjo sensible: absorbe el exceso, reorienta los flujos y redistribuye la intensidad en espiral de escucha diferida.",
    def_long:
      "Sceau d’Aísthisi actúa cuando la experiencia vivida desborda la capacidad subjetiva de contención. Interviene en sobrecargas visuales, auditivas e intuitivas, en sinestesias no integradas, en desbordamientos emocionales de origen perceptivo y en ciertas experiencias espirituales invasivas. No elimina la experiencia: ajusta su velocidad, su densidad y su circulación.\n\n" +
      "Su vínculo matricial conecta los flujos sensoriales internos con el umbral poiético de encarnación vibrante. Cuando la percepción se vuelve demasiado densa, Aísthisi abre una interfaz que vuelve habitable la intensidad al reinscribirla en una circulación espiral. El ser recupera su sostén no por reducción, sino por redistribución.\n\n" +
      "K5 lo sitúa como umbral vivo dentro de Isqun, plenamente katûvýsien, distinto de Katûsýs, Balakallpa y Katûvýsqun, aunque en estrecha sintonía con sus activaciones cuando intensifican el campo perceptivo.",
    h_features: "Referentes estructurantes",
    h_questions: "Referentes de activación",
    hint_fold: "desplegar",
    example_title: "Formulación canónica",
    example:
      "1) Si la percepción desborda: « Aísthisi regula ». 2) Si la sinestesia se vuelve confusión: « Aísthisi redistribuye ». 3) Si la experiencia aplasta el cuerpo: « Aísthisi ralentiza ».",
    features: [
      "Estatus: Sceau régulateur de l’Ennéagone spiralé.",
      "Vínculo matricial: conecta los flujos sensoriales internos con el umbral poiético de encarnación vibrante.",
      "Función principal: regulación de las saturaciones perceptivas.",
      "Naturaleza: plenamente katûvýsien, distinto de Katûsýs, Balakallpa y Katûvýsqun.",
      "Frecuencia armónica: 720.",
      "Onda de alineación común Isqun–Threnisqun: 492.",
      "Campos de acción: sobrecargas visuales, auditivas, intuitivas; sinestesias no integradas; sobreactivaciones emocionales perceptivas."
    ],
    questions: [
      "¿La percepción desborda la capacidad subjetiva de contención?",
      "¿Se trata de una sobrecarga visual, auditiva, intuitiva o emocional perceptiva?",
      "¿La sinestesia actual aclara la vivencia, o produce confusión?",
      "¿Qué medio regulador permite ralentizar el influjo sin quebrar la RéZonans?",
      "¿Hace falta oscurecer, ralentizar, respirar, escribir o entrar en un baño vibratorio en cinco direcciones?"
    ],
    h_family: "Afinidades posœnnoïales",
    family_1:
      "<p><strong>Posición en la Katûvýs:</strong> Sceau d’Aísthisi se sitúa en las fronteras de la experiencia sensible y del umbral vibratorio simbólico. Actúa como tampón fluido entre los <span translate=\"no\" class=\"po-lex-protect\">Katûvýsqun</span> más activos — por ejemplo VITRIOL o <span translate=\"no\" class=\"po-lex-protect\">Katûpirsia</span> intensamente activadas — y las estructuras perceptivas del cuerpo humano. Es filtro poiético, interfaz trans-sensorial y regulador de la intensidad vivida.</p>",
    family_2:
      "<p><strong>Entidad isquniana asociada:</strong> <span translate=\"no\" class=\"po-lex-protect\">Aísthēra</span> es la entidad correspondiente de Sceau d’Aísthisi. Opera como densificación localizada de la función reguladora cuando el exceso perceptivo exige una intervención ritual más marcada. Recoge el influjo, ralentiza la sobrecarga y devuelve la percepción a una cadencia habitable.</p>",
    h_wordbuild: "Posicionamientos y comparaciones",
    word_blocks: [
      {
        head: "Introducción canónica",
        text:
          "Aísthisi nace en la intensidad donde sentir desborda al ser. Los sentidos se hablan directamente, las sinestesias se vuelven primitivas y el influjo puede convertirse en torrente. El sello ofrece entonces equilibrio dentro del exceso, reposo dentro de lo demasiado visto, oído y sentido."
      },
      {
        head: "Frecuencia 720",
        text:
          "K5 fija el siguiente armazón: 720 = 441 + 279. 441 activa la intuición poiética, la visión simbólica y la percepción profunda. 279 activa la permeabilidad encarnada y la intensidad sensible estructurada. La reducción 7 + 2 + 0 = 9 inscribe a Aísthisi en una lógica de integración universal por la experiencia."
      },
      {
        head: "Funcionamiento ritual-simbólico",
        text:
          "Identificar la saturación, colocarse en sintonía silenciosa o en escucha vibratoria suave, activar un medio regulador — baño sonoro, canto lento, movimiento fluido, reposo inmersivo — y concluir con escritura intuitiva o silencio ritualizado para inscribir la huella."
      },
      {
        head: "Redistribución sensorial",
        text:
          "Visual: oscurecimiento ritualizado. Auditiva: sonidos graves, ritmo lento. Olfativa o gustativa: respiración suave. Intuitiva o emocional: voz interior, escritura ritual. Sinestesia generalizada: baño vibratorio en cinco direcciones."
      }
    ],
    word_notes: [
      "Aísthisi es el sello de los hipersensibles, de los poetas encarnados, de los videntes del mundo interior.",
      "No niega la experiencia; ajusta su velocidad, densidad y circulación.",
      "Transforma los choques sensoriales en silencios resonantes y en umbrales de recomposición.",
      "Frase operativa: « Aísthisi (720): reconozco la sobrecarga, ralentizo el influjo y redistribuyo la percepción en espiral de escucha diferida. »"
    ]
  };

  function getFallback(lang){
    var l = normLang(lang) || "fr";
    if (l === "en") return FALLBACK_EN;
    if (l === "es") return FALLBACK_ES;
    return FALLBACK_FR;
  }

  function getAxisLexId(node){
    try{
      return node.getAttribute("data-po-lex-id") || "";
    }catch(e){
      return "";
    }
  }

  function getAxisData(node, lang){
    var l = normLang(lang) || "fr";
    var base = getFallback(l);
    var out = {};
    for (var k in base) out[k] = base[k];

    var lexId = getAxisLexId(node);
    if (lexId){
      var entry = getLexiconEntry(lexId);
      if (entry){
        var termFR = pickTerm(entry, "fr");
        if (termFR) out.title = termFR;

        if (l === "fr"){
          var dsFR = pickDefShort(entry, "fr");
          if (dsFR) out.def_short = dsFR;

          var dlFR = pickDefLong(entry, "fr");
          if (dlFR) out.def_long = dlFR;

          var fFR = pickArray(entry, "fr", "features");
          if (fFR && fFR.length) out.features = fFR;

          var qFR = pickArray(entry, "fr", "questions");
          if (qFR && qFR.length) out.questions = qFR;
        }
      }
    }

    return out;
  }

  function applyToAxis(node){
    var lang = getLang();
    var data = getAxisData(node, lang);

    var chipUrls = (data && Array.isArray(data.chip_urls) && data.chip_urls.length) ? data.chip_urls : [
      IMG_IDEOGRAM_CONCEPT, IMG_IDEOGRAM_FUNCTION, IMG_GUIDE_NUMBER_720
    ];

    setSlotImgSrc(node, "title_img", chipUrls[0] || IMG_IDEOGRAM_CONCEPT, data.title || "");

    setSlotText(node, "title", data.title);
    setSlotText(node, "kicker", data.kicker);
    setSlotText(node, "h_def", data.h_def);

    var chips = Array.isArray(data.chips) ? data.chips : [];
    setSlotText(node, "chip_1", chips[0] || "");
    setSlotText(node, "chip_2", chips[1] || "");
    setSlotText(node, "chip_3", chips[2] || "");

    setSlotImgSrc(node, "chip_1_img", chipUrls[0] || IMG_IDEOGRAM_CONCEPT, chips[0] || "Idéogramme conceptuel");
    setSlotImgSrc(node, "chip_2_img", chipUrls[1] || IMG_IDEOGRAM_FUNCTION, chips[1] || "Idéogramme fonctionnel");
    setSlotImgSrc(node, "chip_3_img", chipUrls[2] || IMG_GUIDE_NUMBER_720, chips[2] || "Nombre guide 720");

    setSlotHTML(node, "def_short", clampStr(data.def_short));
    setSlotHTML(node, "def_long", clampStr(data.def_long));

    setSlotText(node, "h_features", data.h_features);
    setSlotText(node, "hint_fold", data.hint_fold);
    renderList(node, "features", data.features);

    setSlotText(node, "h_questions", data.h_questions);
    setSlotText(node, "hint_fold2", data.hint_fold);
    renderList(node, "questions", data.questions);
    renderExampleBox(node, "example_box", data.example_title, data.example);

    setSlotText(node, "h_family", data.h_family);
    setSlotText(node, "hint_fold3", data.hint_fold);
    setSlotHTML(node, "family_1", data.family_1);
    setSlotHTML(node, "family_2", data.family_2);

    setSlotText(node, "h_wordbuild", data.h_wordbuild);
    renderWordBlocks(node, "wordbuild_blocks", data.word_blocks);
    renderList(node, "wordbuild_notes", data.word_notes);

    setSlotText(node, "cta_translate", data.cta_translate);
  }

  function applyAll(lang){
    var activeLang = normLang(lang) || getLang();
    var nodes = document.querySelectorAll(ROOT_SEL);
    for (var i=0;i<nodes.length;i++){
      applyToAxis(nodes[i]);
    }
    initAudioEverywhere(activeLang);
  }

  function hasLexiconReady(){
    try{
      if (window.PO_LEXICON_MAP) return true;
      if (Array.isArray(window.PO_LEXICON) && window.PO_LEXICON.length) return true;
      if (window.PO_LEXICON_META && window.PO_LEXICON_META.lexique_simplifie_fr) return true;
    }catch(e){}
    return false;
  }

  function init(){
    var existing = readStoredLang();
    if (!existing){
      storeLang(detectBrowserLang());
    }

    applyAll(getLang());

    window.addEventListener("po:lexicon-ready", function(){
      __PO_PROTECT_RE__ = null;
      applyAll(getLang());
    });

    try{
      var mo = new MutationObserver(function(muts){
        for (var i=0;i<muts.length;i++){
          if (muts[i].type === "attributes" && muts[i].attributeName === "lang"){
            applyAll(getLang());
            notifyLocaleChanged();
            break;
          }
        }
      });
      if (document && document.documentElement){
        mo.observe(document.documentElement, { attributes:true });
      }
    }catch(e){}

    if (!hasLexiconReady()){
      var tries = 0;
      var maxTries = 24;
      var it = setInterval(function(){
        tries++;
        if (hasLexiconReady() || tries >= maxTries){
          clearInterval(it);
          __PO_PROTECT_RE__ = null;
          applyAll(getLang());
        }
      }, 250);
    }
  }

  window.PoKatupirsia5SceauDAisthisiTextsFR_EN_ES_20260307 = {
    init: init,
    getLang: getLang,
    normLang: normLang,
    setLang: function(raw){
      var l = normLang(raw) || "fr";
      storeLang(l);
      __PO_PROTECT_RE__ = null;
      applyAll(l);
      notifyLocaleChanged();
      return l;
    },
    stopAudio: stopAudio
  };

  window.GoodyTwinLang = window.GoodyTwinLang || {};
  window.GoodyTwinLang.init = init;
  window.GoodyTwinLang.getLang = getLang;
  window.GoodyTwinLang.setLang = function(lang){
    return window.PoKatupirsia5SceauDAisthisiTextsFR_EN_ES_20260307.setLang(lang);
  };

  if (document.readyState === "loading"){
    document.addEventListener("DOMContentLoaded", init);
  }else{
    init();
  }

})();